export default __webpack_public_path__ + "static/GOOP_mobile@3x-80e123b92a9ce26d5708c70f9ca12533.png";